export enum ServiceFunctionActionType {
  Execute = '@quidproquo-webserver/ServiceFunction/Execute',
}
